import { NgModule } from '@angular/core';
import { PHBHPLocalizePackageModule } from 'ph-bhp-feature-packages/ph-bhp-localize-package/public_api';
import { PHBHPLayoutPackageModule } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import {NgxMaskModule} from 'ngx-mask';
import { ConsumptionComponent } from './consumption/consumption.component';

import { PHBHPFeaturePackageConsumptionComponent } from './ph-bhp-feature-package-consumption.component';
import { PhBhpQuarterConsumptionComponent } from './ph-bhp-quarter-consumption/ph-bhp-quarter-consumption.component';
import { PhBhpNewConsumptionComponent } from './ph-bhp-new-consumption/ph-bhp-new-consumption.component';
import { PhBhpPastConsumptionComponent } from './ph-bhp-past-consumption/ph-bhp-past-consumption.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PhBhpYearConsumptionComponent } from './ph-bhp-year-consumption/ph-bhp-year-consumption.component';
import { PhBhpMonthConsumptionComponent } from './ph-bhp-month-consumption/ph-bhp-month-consumption.component';
import { PhBhpViewMonthConsumptionComponent } from './ph-bhp-view-month-consumption/ph-bhp-view-month-consumption.component';
import { PhBhpViewYearConsumptionComponent } from './ph-bhp-view-year-consumption/ph-bhp-view-year-consumption.component';
import { PhBhpViewQuarterConsumptionComponent } from './ph-bhp-view-quarter-consumption/ph-bhp-view-quarter-consumption.component';
import { PhBhpParentViewConsumptionComponent } from './ph-bhp-parent-view-consumption/ph-bhp-parent-view-consumption.component';
import { PhBhpUiModule } from 'ph-bhp-feature-packages/ph-bhp-ui/src/lib/ph-bhp-ui.module'; 
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { MatIconModule } from "@angular/material/icon";
import { ClientLibModule } from 'ph-bhp-feature-packages/ph-bhp-feature-package-check/public_api';
import { PhBhpFeatureComponentsModule } from 'ph-bhp-feature-packages/ph-bhp-feature-components/public_api';

// common libraries


@NgModule({
  declarations: [
    ConsumptionComponent,
    PHBHPFeaturePackageConsumptionComponent, 
    PhBhpQuarterConsumptionComponent, 
    PhBhpNewConsumptionComponent, 
    PhBhpPastConsumptionComponent, 
    PhBhpYearConsumptionComponent, 
    PhBhpMonthConsumptionComponent, 
    PhBhpViewMonthConsumptionComponent, 
    PhBhpViewYearConsumptionComponent, 
    PhBhpViewQuarterConsumptionComponent, 
    PhBhpParentViewConsumptionComponent
  ],
  imports: [
    PHBHPLocalizePackageModule, PHBHPLayoutPackageModule, FormsModule, MatInputModule, MatFormFieldModule, MatSlideToggleModule, ReactiveFormsModule,NgxMaskModule.forRoot(), PhBhpUiModule, MatIconModule, ClientLibModule, PhBhpFeatureComponentsModule
  ]
})
export class PHBHPFeaturePackageConsumptionModule { }
